module.exports = __webpack_public_path__ + "static/image7-671eee76dd60383721ae263d46e3b4a9.png";